// src/config/api.js
// Configuración centralizada de la API

const getDynamicBaseUrl = () => {
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'http://localhost:3001/api';
  }
  return 'https://riasbaixaspd.es/api';
};

const API_CONFIG = {
  // URL base de la API - ProyectoRP backend
  BASE_URL: getDynamicBaseUrl(),
  
  // URLs específicas para diferentes servicios
  ENDPOINTS: {
    // Autenticación
    LOGIN: '/login',
    
    // Usuarios
    USERS: '/users',
    
    // Roles
    ROLES: '/roles',
    
    // Whitelist
    WHITELIST_REQUESTS: '/whitelistRequests',
    
    // Sistema
    MAINTENANCE: '/maintenance',
    SYSTEM_CONFIG: '/system-config',
    
    // Contador de jugadores
    PLAYER_COUNT: '/get_player_count',
    
    // Mantenimiento FiveM
    FIVEM_MAINTENANCE: '/fivem-maintenance',
    
    // Logs
    LOGS: '/logs',
    
    // Alertas
    ALERTS: '/alerts',
    ACTIVE_ALERTS: '/alerts/active'
  }
};

// Función helper para construir URLs completas
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Función helper para hacer peticiones con autenticación
export const fetchWithAuth = async (endpoint, options = {}) => {
  const token = localStorage.getItem('authToken');
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers
    },
    ...options
  };

  const response = await fetch(getApiUrl(endpoint), defaultOptions);
  return response;
};

// Exportar configuración
export default API_CONFIG;

// Para compatibilidad con código existente
export const API_BASE_URL = API_CONFIG.BASE_URL;